export default __webpack_public_path__ + "scene2_1_bg38140d.png";